import React from 'react';
import Translate from '@spordle/intl-elements';

import Table from '../Table';
import Loader from '../Loader';

import { TableHeader, TableRow } from './StatsTableBody';

export default ({ participantType, filters, group, currentRows, status, statuses = [ status ], isSingle, scheduleRequired, showGroup = false, properties, hidePositions, hideRank, disableSorting, querySort, queryOrder, handleSorting, ...props }) =>
  <Table
    className="stats-table"
    currentRows={currentRows}
    group={group}
    isSingle={isSingle}
    renderMessage={() => {
      if (statuses.every(status => status === 'idle') || (scheduleRequired && !filters?.scheduleId)) return <div></div>
      if (statuses.includes('error')) return <p><Translate id={`components.participantstats.loading.fail.${participantType.toLowerCase()}`} /></p>
      if (statuses.includes('loading')) return <Loader><Translate id="components.participantstats.loading" /></Loader>
      if (!currentRows?.length) return <p>
        {group && <h6 className="font-weight-bold border-top border-bottom py-2 px-1">{group.name}</h6>}
        <Translate id={`components.participantstats.no.stats.${participantType.toLowerCase()}`} />
      </p>
      return null;
    }}
    renderHeader={({ isMobile }) =>
      <TableHeader
        isMobile={isMobile}
        isSingle={isSingle}
        properties={properties}
        hidePositions={hidePositions}
        hideRank={hideRank}
        disableSorting={disableSorting}
        querySort={querySort}
        queryOrder={queryOrder}
        handleSorting={handleSorting}
      />
    }
    renderGroupHeader={group => {
      if (!group?.id) return null;
      return <tr key={group.id}>
        <th colSpan={17} scope="colgroup">{group.name}</th>
      </tr>
    }}
    renderRow={({ isMobile, row: player, index }) =>
      <TableRow
        key={player.stats?.id || player.id}
        index={index}
        player={player}
        isMobile={isMobile}
        isSingle={isSingle}
        showGroup={showGroup}
        properties={properties}
        hidePositions={hidePositions}
        hideRank={hideRank}
        querySort={querySort}
      />
    }
    {...props}
  />
